'use client';

import React from 'react';
import { IconPickerItem } from 'react-icons-picker';

export default function Icon({ value }) {
	return (
		<IconPickerItem value={value} />
	);
}
